import { motion } from 'framer-motion'

interface MonitorRecorderIconProps {
    className?: string
    size?: number
    animate?: boolean
    color?: string
}

export default function MonitorRecorderIcon({
    className = '',
    size = 24,
    animate = true,
    color = 'currentColor'
}: MonitorRecorderIconProps) {
    // Custom Bezier curve easing matching Lottie/Iconly spring behavior: cubic-bezier(0.34, 1.56, 0.64, 1)
    const bezierElastic = [0.34, 1.56, 0.64, 1]

    return (
        <motion.svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            whileHover={animate ? { scale: 1.12, rotate: [0, -3, 3, 0] } : undefined}
            transition={{ duration: 0.4, ease: bezierElastic }}
        >
            {/* Main Monitor Screen with Notch Cutout */}
            <motion.path
                d="M20.97 10.37V13.56C20.97 15.88 19.09 17.76 16.77 17.76H13.21C12.66 17.76 12.21 18.2 12.21 18.76V19.58C12.21 20.13 12.66 20.58 13.21 20.58H15.47C15.86 20.58 16.18 20.89 16.18 21.29C16.18 21.68 15.86 22 15.47 22H7.53C7.14 22 6.82 21.68 6.82 21.29C6.82 20.89 7.14 20.58 7.53 20.58H9.79C10.34 20.58 10.79 20.13 10.79 19.58V18.76C10.79 18.2 10.34 17.76 9.79 17.76H6.19C3.88 17.76 2 15.88 2 13.56V7.19C2 4.88 3.88 3 6.19 3H10.5C11.05 3 11.5 3.45 11.5 4V6.15C11.5 8.08 12.79 9.37 14.71 9.37H19.97C20.52 9.37 20.97 9.82 20.97 10.37Z"
                fill={color}
            />

            {/* Embedded Top-Right Camera Recorder with Bezier Spring Pulse */}
            <motion.path
                d="M21.99 2.35962L20.86 3.14962V2.72962C20.86 1.77962 20.09 1.01962 19.15 1.01962H14.87C13.84 1.00962 13 1.84962 13 2.87962V6.15962C13 7.18962 13.84 8.02962 14.87 8.02962H19.14C20.09 8.02962 20.85 7.25962 20.85 6.15962V5.72962L21.99 6.51962C22.28 6.71962 22.67 6.50962 22.67 6.15962V2.71962C22.67 2.36962 22.28 2.15962 21.99 2.35962Z"
                fill={color}
                animate={
                    animate
                        ? {
                            scale: [1, 1.15, 1],
                            opacity: [1, 0.85, 1],
                        }
                        : undefined
                }
                transition={{
                    duration: 1.8,
                    repeat: Infinity,
                    ease: bezierElastic,
                }}
            />
        </motion.svg>
    )
}
